import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useAuthStore } from '../../../store/authStore'
import { supabase } from '../../../lib/supabase'

export const useMessages = () => {
  const household = useAuthStore((s) => s.household)
  const qc        = useQueryClient()
  const key       = ['messages', household?.id]

  const query = useQuery({
    queryKey: key,
    enabled:  !!household?.id,
    queryFn:  async () => {
      const { data, error } = await supabase
        .from('messages')
        .select('id, body, created_at, profiles:sender_id(id, display_name, member_color)')
        .eq('household_id', household.id)
        .order('created_at', { ascending: true })
        .limit(200)
      if (error) throw error
      return data ?? []
    },
  })

  // Realtime subscription
  useEffect(() => {
    if (!household?.id) return
    const channel = supabase
      .channel(`messages:${household.id}`)
      .on('postgres_changes',
        { event: 'INSERT', schema: 'public', table: 'messages', filter: `household_id=eq.${household.id}` },
        () => qc.invalidateQueries({ queryKey: key }),
      )
      .subscribe()
    return () => { supabase.removeChannel(channel) }
  }, [household?.id])

  const sendMessage = useMutation({
    mutationFn: async (body) => {
      const { data: { session } } = await supabase.auth.getSession()
      const { error } = await supabase
        .from('messages')
        .insert({ household_id: household.id, sender_id: session.user.id, body })
      if (error) throw error
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  })

  const deleteMessage = useMutation({
    mutationFn: async (id) => {
      const { error } = await supabase.from('messages').delete().eq('id', id)
      if (error) throw error
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  })

  return { ...query, sendMessage, deleteMessage }
}
